import React from 'react';
import '../../styles/onboardingFlow/mobileLogoCard/mobileLogoSlide1.scss';
import hubspotIcon from '../../assets/onboarding/slides/slide1/hubspot.svg';
import searchInput from '../../assets/onboarding/slides/slide1/search-input.svg';
import chat1 from '../../assets/onboarding/slides/slide1/chat1.svg';
import chat2 from '../../assets/onboarding/slides/slide1/chat2.svg';
import chat3 from '../../assets/onboarding/slides/slide1/chat3.png';
import googleLogo from '../../assets/onboarding/slides/slide1/google.svg';

const MobileLogoSlide1: React.FC = () => {
  return (
    <div className='mobileLogoSlide1'>
      <div className='mobileLogoSlide1__content'>
        <div className='mobileLogoSlide1__hubspot'>
          <img src={hubspotIcon} alt='HubSpot' />
        </div>
        <div className='mobileLogoSlide1__chats'>
          <div className='mobileLogoSlide1__chat mobileLogoSlide1__chat--1'>
            <img src={chat1} alt='Chat 1' />
          </div>
          <div className='mobileLogoSlide1__chat mobileLogoSlide1__chat--2'>
            <img src={chat2} alt='Chat 2' />
          </div>
          <div className='mobileLogoSlide1__chat mobileLogoSlide1__chat--3'>
            <img src={chat3} alt='Chat 3' />
          </div>
        </div>
        <div className='mobileLogoSlide1__search-container'>
          <div className='mobileLogoSlide1__search'>
            <div className='mobileLogoSlide1__search-input'>
              <img src={searchInput} alt='Ask Tara' />
            </div>
          </div>
          <div className='mobileLogoSlide1__google'>
            <img src={googleLogo} alt='Google' />
          </div>
        </div>
      </div>
    </div>
  );
};

export default MobileLogoSlide1;
